$('.carousel').carousel({
  interval: 2000
})
$('#click-toggle').click(function(e){
  e.stopPropagation();
$(".dropdown-toggle").dropdown('toggle');// this doesn't
});

